import { render, staticRenderFns } from "./MealsTab.vue?vue&type=template&id=03eba571"
import script from "./MealsTab.vue?vue&type=script&lang=js"
export * from "./MealsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports